export default __webpack_public_path__ + "static/media/enugutech.fc2220c5.webp";